// Small promise-based replacements for window.prompt / window.confirm, using a
// transient <dialog>. Keeps the app free of blocking native dialogs.

function buildDialog(inner: string): HTMLDialogElement {
  const dlg = document.createElement("dialog");
  dlg.className = "dialog";
  dlg.innerHTML = `<form method="dialog">${inner}</form>`;
  document.body.appendChild(dlg);
  dlg.addEventListener("close", () => dlg.remove());
  return dlg;
}

export function textPrompt(
  title: string,
  initial = "",
  { label = "Name", confirmLabel = "Speichern" } = {}
): Promise<string | null> {
  return new Promise((resolve) => {
    const dlg = buildDialog(`
      <h2>${title}</h2>
      <div class="field">
        <label for="tpInput">${label}</label>
        <input type="text" id="tpInput" />
      </div>
      <div class="dialog-actions">
        <button type="button" class="btn ghost" data-a="cancel">Abbrechen</button>
        <button type="submit" class="btn primary" data-a="ok">${confirmLabel}</button>
      </div>`);
    const input = dlg.querySelector<HTMLInputElement>("#tpInput")!;
    input.value = initial;
    let done = false;
    const finish = (value: string | null) => {
      if (done) return;
      done = true;
      resolve(value);
      dlg.close();
    };
    dlg.querySelector('[data-a="cancel"]')!.addEventListener("click", () => finish(null));
    dlg.querySelector("form")!.addEventListener("submit", () => finish(input.value.trim() || null));
    dlg.addEventListener("cancel", () => finish(null));
    dlg.showModal();
    input.focus();
    input.select();
  });
}

export function confirmDialog(
  title: string,
  message: string,
  { confirmLabel = "Löschen", danger = true } = {}
): Promise<boolean> {
  return new Promise((resolve) => {
    const dlg = buildDialog(`
      <h2>${title}</h2>
      <p style="margin:0 0 16px; line-height:1.55; color:var(--ink-600);">${message}</p>
      <div class="dialog-actions">
        <button type="button" class="btn ghost" data-a="cancel">Abbrechen</button>
        <button type="submit" class="btn ${danger ? "" : "primary"}" data-a="ok"
          ${danger ? 'style="background:var(--danger); border-color:var(--danger); color:#fff;"' : ""}>${confirmLabel}</button>
      </div>`);
    let done = false;
    const finish = (value: boolean) => {
      if (done) return;
      done = true;
      resolve(value);
      dlg.close();
    };
    dlg.querySelector('[data-a="cancel"]')!.addEventListener("click", () => finish(false));
    dlg.querySelector("form")!.addEventListener("submit", () => finish(true));
    dlg.addEventListener("cancel", () => finish(false));
    dlg.showModal();
  });
}
